import type { AgentState, RoomJoinPolicy } from './types';

/**
 * Should the webphone be in its conference room right now? (AE-10989, decision #9.)
 * `readyIntent` is true from the Ready click until the agent pauses or logs out: the join has to
 * start before agent-state says ready, or a call reserved in that window bridges the customer
 * into an empty room.
 */
export function wantRoom(policy: RoomJoinPolicy | undefined, state: AgentState, readyIntent: boolean): boolean {
  switch (policy ?? 'on_login') {
    case 'on_login': return true;
    case 'on_ready': return readyIntent || state === 'ready' || state === 'reserved' || state === 'on_call' || state === 'wrap';
    case 'on_offer': return state === 'reserved' || state === 'on_call';
  }
}
